<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex ">
            <section class="mu-d-flex mu-flex-row">
                <h1 class="mu-mb-00">Job details</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">
                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
        </div>
    </div>
    <div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb ">
                    <li>Process engine</li>
                    <li>
                        <router-link class="table-link" :to="CONTEXT_PATH + '/processengine/jobs'">Jobs</router-link>
                    </li>
                    <li>{{jobInfo.id}}</li>

                  
                </ol>
            </nav>
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-card">
               <div class="mcc-card__body">
                <div class="mcc-row"><div class="mcc-col">
                        <div class="mcc-card fullCardWidth" v-if="fetchCall">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Details</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <div >
                                            <table>
                                                <tbody>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">ID</div>
                                                        <div class="mcc-col">{{jobInfo.id}}</div>
                                                    </div>
                                                    <div class="seperator mu-my-03"></div>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">Job type</div>
                                                        <div class="mcc-col">{{jobType}}</div>
                                                    </div>
                                                    <div class="seperator mu-my-03"></div>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">Created</div>
                                                        <div class="mcc-col">{{createTime}}</div>
                                                    </div>
                                                    <div class="seperator mu-my-03"></div>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">Due</div>
                                                        <div class="mcc-col">{{dueDate}}</div>
                                                    </div>
                                                    <div class="seperator mu-my-03"></div>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">Process definition</div>
                                                        <div class="mcc-col">{{jobInfo.processDefinitionId}}</div>
                                                    </div>
                                                    <div class="seperator mu-my-03"></div>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">Process instance</div>
                                                        <div class="mcc-col">{{jobInfo.processInstanceId}}</div>
                                                    </div>
                                                    <div class="seperator mu-my-03"></div>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">Exclusive</div>
                                                        <div class="mcc-col">{{isExclusive}}</div>
                                                    </div>
                                                    <div class="seperator mu-my-03"></div>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col">Retries left</div>
                                                        <div class="mcc-col">{{jobInfo.retries}}</div>
                                                    </div>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                   </div>
                   <div class="mcc-col">
                        <div class="mcc-card fullCardWidth" v-if="fetchCall">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title">Exception</h2>
                            </div>
                            <div class="mcc-card__body">
                                <div id="jobExceptionMsg">{{jobInfo.exceptionMessage}}
                                </div>
                            </div>
                        </div>
                   </div></div><div class="mu-d-flex mu-justify-content-end d-flex justify-content-end mu-mt-05">
                                    <button class="mcc-button mcc-button--soft-danger " title="Delete" id="deleteJobBtn" @click="openDelJobDialog()">
                                        <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                                    </button>
                                </div>
                </div>
                </div>
            </div>
            <div class="mcc-dialog-overlay">
                <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" color="danger" ref="delJobDialog" id="delJobDialog">
                    <section>
                        <div class="mcc-dialog__header">
                            <h2 class="h4">Delete job</h2>
                            <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.delJobDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                        </div>
                        <div class="mcc-dialog__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    Are you sure you want to delete job?
                                </div>
                            </div>
                        </div>
                        <div class="mcc-dialog__footer">
                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" class="mcc-button mcc-button--outline" @click="$refs.delJobDialog.close()">No</button>
                                <button type="button" class="mcc-button mcc-button--danger" @click="handleDelJobDialogClose($event)">Yes</button>
                            </div>
                        </div>
                    </section>
                </dialog>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import JobAPI from "../../../services/JobAPI";
import {
    EventBus
} from "../../../services/event-bus";
import Utils from "@/script_utils";

export default {
    name: "JobEdit",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP[
                "processengine.job.edit"
            ],
            jobInfo: {},
            createTime: "",
            dueDate: "",
            jobId: this.$route.params.jobId,
            jobType: this.$route.query.jobType,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            fetchCall: false,
            showHelpText: false,
            isExclusive: ""
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        JobAPI.getJobDetail(this.$route.params.jobId, this.$route.query.jobType)
            .then(result => {
                if (result == null) {
                    localStorage.setItem("jobList", "jobList");
                    self.$router.push(
                        self.CONTEXT_PATH + "/processengine/jobs"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching job details."
                    });
                    return;
                }
                self.jobInfo = result.jobInfo;
                self.createTime = result.createTime;
                self.dueDate = result.dueDate;
                self.isExclusive = result.isExclusive;
                self.jobType = result.jobType;
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.job.details"] + " - " + self.jobInfo.id;
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(() => {
                self.fetchCall = true;
            });
    },
    methods: {
        openDelJobDialog() {
            this.$refs.delJobDialog.show();
        },
        handleDelJobDialogClose(e) {
            let self = this;
            if (e.target) {
                JobAPI.deleteJob(this.jobId, this.jobType).then(result => {
                    if (!result.error) {
                        localStorage.setItem("jobList", "jobList");
                        EventBus.$emit('success-notification', {
                            "msg": "Job deleted successfully"
                        });
                        self.$router.push(
                            self.CONTEXT_PATH + '/processengine/jobs'
                        );
                    }
                });
            }
        },
        redirectToList() {
            localStorage.setItem("jobList", "jobList");
            this.$router.push(
                this.CONTEXT_PATH + '/processengine/jobs'
            );
        }
    }
};
</script>
